/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
 */

import pluginFactory from 'taoTests/runner/plugin';

/**
 * Prevent drop images to inputs
 */
export default pluginFactory({
    name: 'preventDropToInput',

    install() {
        this.eventHandlers = [];

        this.preventDragAndDrop = event => {
            event.preventDefault();
            event.stopPropagation();
        };

        this.addEventListeners = (elements, events, handler) => {
            elements.forEach(element => {
                events.forEach(event => {
                    element.addEventListener(event, handler);
                    this.eventHandlers.push({ element, type: event, handler });
                });
            });
        };

        this.removeEventListeners = () => {
            this.eventHandlers.forEach(({ element, type, handler }) => {
                element.removeEventListener(type, handler);
            });
            this.eventHandlers = [];
        };
    },

    init() {
        const testRunner = this.getTestRunner();
        const container = testRunner.getAreaBroker().getContainer();

        const prevent = () => {
            const inputs = container.querySelectorAll("input[type='text']");
            const textareas = container.querySelectorAll(
                ".qti-extendedTextInteraction:not([data-format='xhtml']) textarea"
            );
            this.addEventListeners([...inputs, ...textareas], ['drop'], this.preventDragAndDrop);
        };

        const cleanUp = () => {
            this.removeEventListeners();
        };

        testRunner.on('renderitem', prevent);
        testRunner.on('unloaditem', cleanUp);
    },

    destroy() {
        this.removeEventListeners();
    }
});
